// Keep the worker URL next to its constructor so Vite bundles it separately.
export function createFractalWorker() {
  return new Worker(new URL('./fractal.worker.js', import.meta.url), { type: 'module' });
}
